import React from "react";
import Dropdown from "components/dropdown";
import { AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineFieldTime, AiOutlineUser } from "react-icons/ai";
import { BsThreeDots } from "react-icons/bs";
import { FiSettings } from "react-icons/fi";
import { AiOutlineShop } from "react-icons/ai";
import { TiLightbulb } from "react-icons/ti";

function CardMenuDropdown(props) {
  const { transparent, name, handleOpenUser, options } = props;
  const [open, setOpen] = React.useState(false);
  return (
    <Dropdown
      button={
        <button
          onClick={() => setOpen(!open)}
          open={open}
          className={`flex items-center text-md hover:cursor-pointer ${transparent
            ? "bg-none text-white hover:bg-none active:bg-none"
            : "bg-navy-700 p-2 text-white hover:bg-gray-100 hover:bg-white/20 active:bg-white/10"
            } linear justify-center rounded-lg font-bold transition duration-200`}
        >
          {name}
        </button>
      }
      animation={"origin-top-right transition-all duration-300 ease-in-out"}
      classNames={`${transparent ? "top-8" : "top-11"} right-0 w-max`}
      children={
        <div className="z-50 w-max rounded-xl !bg-navy-700 px-4 py-3 text-sm shadow-none shadow-shadow-500">
          {options?.map((option) =>
            <p className="flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium hover:text-black" onClick={() => handleOpenUser(option)}>
              <span>
                {/* <AiOutlineFieldTime /> */}{option.icon}
              </span>
              {option.label}
            </p>
          )}
          {/* <p className="mt-2 flex cursor-pointer items-center gap-2 pt-1 text-gray-600 hover:font-medium hover:text-black">
            <span>
              <AiOutlineCheckCircle />
            </span>
            Approved
          </p>
          <p className="mt-2 flex cursor-pointer items-center gap-2 pt-1 text-gray-600 hover:font-medium hover:text-black">
            <span>
              <AiOutlineCloseCircle />
            </span>
            Rejected
          </p> */}
        </div>
      }
    />
  );
}

export default CardMenuDropdown;
